import { faker } from '@faker-js/faker'

import { UserReservationSlot } from '../../contracts/reservation/ReservationSlot'
import { asBuilder } from '../asBuilder'

const startTimes = ['10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00']
export const getReservationSlots = asBuilder<UserReservationSlot[]>((): UserReservationSlot[] => {
  const startTime = startTimes[faker.number.int({ min: 0, max: 5 })]
  return faker.helpers.multiple(
    () => ({
      baseDate: faker.date.recent().toISOString().split('T')[0],
      isHospitalHoliday: faker.datatype.boolean(),
      slotList: Array.from({ length: 10 }, () => ({
        id: faker.number.int(),
        reservationCount: faker.number.int({ min: 0, max: 5 }),
        thresholdCount: faker.number.int({ min: 5, max: 10 }),
        startTime,
        endTime: startTimes[startTimes.indexOf(startTime) + 1],
        enable: faker.datatype.boolean(),
      })),
    }),
    { count: 7 },
  )
})
